import { render, staticRenderFns } from "./FieldModalFixedPeripherals.vue?vue&type=template&id=211cfa89&scoped=true&"
import script from "./FieldModalFixedPeripherals.vue?vue&type=script&lang=js&"
export * from "./FieldModalFixedPeripherals.vue?vue&type=script&lang=js&"
import style0 from "./FieldModalFixedPeripherals.vue?vue&type=style&index=0&id=211cfa89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211cfa89",
  null
  
)

export default component.exports